module.exports = __webpack_public_path__ + "img/IMG_6984_L_WoodMatted_MockedUp.abe4a38f.jpg";